
import { Vue, Component } from "vue-property-decorator";
import { formatDate } from "../../../utils";
import { getModule } from "vuex-module-decorators";
import LoadModule from "@/store/modules/barcodeSystem/load";
import { LoadResource } from "@/models/api/barcodeSystem/loads/get";

const loadModuleState = getModule(LoadModule);

@Component
export default class LoadHeader extends Vue {
  showUnlockLoadPrompt: boolean = false;
  get currentLoad(): LoadResource {
    return loadModuleState.currentLoad;
  }

  get loadName(): string {
    return loadModuleState.currentLoad
      ? loadModuleState.currentLoad.loadName
      : ""; 
  }

  get companyName(): string {
    return loadModuleState.currentLoad
      ? loadModuleState.currentLoad.companyName
      : ""; 
  }

  set companyName(val: string){
  }

  get islocked(): boolean {
    return loadModuleState.currentLoad
      ? loadModuleState.currentLoad.isLocked
      : false; 
  }

  get locked(): string {
    return loadModuleState.currentLoad
      ? loadModuleState.currentLoad.locked
      : ""; 
  }

  set locked(val: string){
  }

  get displayBillToCompanyId(): string {
    return loadModuleState.currentLoad
      ? loadModuleState.currentLoad.displayBillToCompanyId
      : ""; 
  }

  set displayBillToCompanyId(val: string){
  }

  get facilityCode(): string {
    return loadModuleState.currentLoad
      ? loadModuleState.currentLoad.facilityCode
      : ""; 
  }

  set facilityCode(val: string){
  }

  get importedDateTimeFormatted(): string {
    return loadModuleState.currentLoad
      ? formatDate(loadModuleState.currentLoad.importedDate)
      : "";
  }

  set importedDateTimeFormatted(val: string){
  }

  promptForUnlockLoad()
  {
    this.showUnlockLoadPrompt=true;
  }

  closeUnlockLoadPrompt()
  {
    this.showUnlockLoadPrompt=false;
  }

  unlockLoad() {
    this.closeUnlockLoadPrompt();
    this.$emit("unlockLoad");
  }
  
}
